// extracted by mini-css-extract-plugin
export var actionButton = "_im-0";
export var actionMenuContainer = "_im-i";
export var bubble = "_im-2";
export var bubbleActionMenu = "_im-j";
export var bubbleContext = "_im-6";
export var bubbleItems = "_im-7";
export var customer = "_im-3";
export var divider = "_im-8";
export var fileList = "_im-9";
export var hiddenComment = "_im-o";
export var infoAbove = "_im-a";
export var internal = "_im-4";
export var lightActionButton = "_im-1";
export var link = "_im-b";
export var merchant = "_im-5";
export var message = "_im-c";
export var profilePicture = "_im-e";
export var quillToolbarContainer = "_im-f";
export var senderDate = "_im-g";
export var senderDateCustomer = "_im-h";
export var senderName = "_im-d";
export var time = "_im-k";
export var uploadedImage = "_im-l";
export var username = "_im-m";
export var xsmall = "_im-n";